import { trim, isNumber, isInteger } from 'lodash';
const tr = require('ts-translate-js').default.boundTR;

//TODO: 2024-11-08 - Fix this regex. Right now, it raises following linter errors:
// - sonarjs/unnecessary-character-escapes
// - sonarjs/duplicates-in-character-class
//eslint-disable-next-line
const EMAIL_VALIDATION_REGEX = /^[\d\w\.\-]+@[\d\w\-]+\.[\d\w\.]+$/; // eslint-disable-line no-useless-escape

// Anything between 3 and 11 char
//TODO: 2024-11-08 - Fix this regex. Right now, it raises following linter errors:
// - sonarjs/unnecessary-character-escapes
// - sonarjs/duplicates-in-character-class
//eslint-disable-next-line
const POSTALCODE_WORLD_VALIDATION_REGEX = /^[\-\w\d\s]{3,11}$/; // eslint-disable-line no-useless-escape

const F_STRING = 'STRING';
const F_DATE = 'DATE';
const F_BIRTHDATE = 'BIRTHDATE';
const F_EMAIL = 'EMAIL';
const F_POSTALCODE = 'POSTALCODE';
const F_MULTILINE = 'MULTILINE';
const F_ONEOF = 'ONEOF';
const F_INT = 'INT';
const F_BOOL = 'BOOL';
const F_MULTIPLE_VALUES = 'MULTIPLE_VALUES';
const F_MULTIPLE_DOCUMENTS = 'MULTIPLE_DOCUMENTS';
const F_TAGS = 'TAGS';
const F_DECIMAL = 'DECIMAL';

const FIELD_VALUE_TYPE_BY_JSTYPE = {
    "string": F_STRING,
    "number": F_INT
};

const FV_REQUIRED_STRING = (value) => value !== undefined && trim(value.toString()).length > 0;
const FV_REQUIRED_INT = (value) => value !== undefined;
const FV_REQUIRED_DATE = (value) => value !== undefined;
const FV_REQUIRED_BOOL = (value) => value !== undefined;
const FV_REQUIRED_TAGS = (value) => value !== undefined && trim(value.toString()).length > 0;
const FV_REQUIRED_DECIMAL = (value) => value !== undefined;
//const FV_VALID_INT = (value) => [];

const ERR_REQUIRED = 'REQUIRED';
const ERR_INVALID_EMAIL = 'INVALID_EMAIL';
const ERR_INVALID_POSTALCODE = 'INVALID_POSTALCODE';
const ERR_INVALID_DECIMAL = 'INVALID_DECIMAL';
const ERR_INVALID_INT = 'INVALID_INT';
const ERR_MUST_BE_TRUE = 'MUST_BE_TRUE';


//TODO: Need translations here.
const TEMP_TRANSLATIONS = {
    [ERR_REQUIRED]: tr('Requis'),
    [ERR_INVALID_EMAIL]: tr('Courriel invalide'),
    [ERR_INVALID_POSTALCODE]: tr('Code postal invalide'),
    [ERR_INVALID_DECIMAL]: tr('Nombre invalide'),
    [ERR_INVALID_INT]: tr('Le nombre doit être un entier'),
    [ERR_MUST_BE_TRUE]: tr('Vous devez cocher la case pour continuer')
};

//#region Private validators
function validateString(value, isRequired, isSubField) {
    if (!isSubField && isRequired && !FV_REQUIRED_STRING(value)) {
        return [{ type: ERR_REQUIRED }];
    }

    return [];
}

function validateEmail(email, isRequired) {
    if (isRequired && !FV_REQUIRED_STRING(email)) {
        return [{ type: ERR_REQUIRED }];
    }

    if (!EMAIL_VALIDATION_REGEX.test(email)) {
        return [ { type: ERR_INVALID_EMAIL } ];
    }
    
    return [];
}

function validatePostalCode(postalCode, isRequired) {
    if (isRequired && (!FV_REQUIRED_STRING(postalCode) || !FV_REQUIRED_INT(postalCode))) {
        return [{ type: ERR_REQUIRED }];
    }

    if (!POSTALCODE_WORLD_VALIDATION_REGEX.test(postalCode)) {
        return [ { type: ERR_INVALID_POSTALCODE } ];
    }
    
    return [];
}

function validateDate(date, isRequired) {
    if (isRequired  && !FV_REQUIRED_DATE(date)) {
        return [{ type: ERR_REQUIRED }];
    }

    return [];
}

function validateBool(bool, isRequired, mustBeTrue) {
    if (isRequired  && !FV_REQUIRED_BOOL(bool)) {
        return [{ type: ERR_REQUIRED }];
    }

    if(mustBeTrue && !bool) {
        return [{ type: ERR_MUST_BE_TRUE }];
    }

    return [];
}

function validateTags(tags, isRequired) {
    if (isRequired  && !FV_REQUIRED_TAGS(tags)) {
        return [{ type: ERR_REQUIRED }];
    }

    return [];
}

function validateNumber(number, isRequired) {
    if (isRequired  && !FV_REQUIRED_DECIMAL(number)) {
        return [{ type: ERR_REQUIRED }];
    }

    if(!isNumber(Number(number)) || number === "") {
        return [{ type: ERR_INVALID_DECIMAL }];
    }

    return [];
}

function validateInt(integer, isRequired) {
    if (isRequired  && !FV_REQUIRED_INT(integer)) {
        return [{ type: ERR_REQUIRED }];
    }

    if(!isInteger(parseInt(integer)) || integer === "") {
        return [{ type: ERR_INVALID_INT }];
    }

    return [];
}



//#endregion

export class Validator {

    //#region Constants accessors
    static get EMAIL_VALIDATION_REGEX() {
        return EMAIL_VALIDATION_REGEX;
    }

    static get POSTALCODE_WORLD_VALIDATION_REGEX() {
        return POSTALCODE_WORLD_VALIDATION_REGEX;
    }

    static get F_STRING() {
        return F_STRING;
    }

    static get F_DATE() {
        return F_DATE;
    }

    static get F_BIRTHDATE() {
        return F_BIRTHDATE;
    }

    static get F_EMAIL() {
        return F_EMAIL;
    }

    static get F_ONEOF() {
        return F_ONEOF;
    }

    static get F_POSTALCODE() {
        return F_POSTALCODE;
    }

    static get F_BOOL() {
        return F_BOOL;
    }

    static get F_DECIMAL() {
        return F_DECIMAL;
    }

    static get F_INT() {
        return F_INT;
    }

    static get F_TAGS() {
        return F_TAGS;
    }
    
    static get F_MULTIPLE_VALUES() {
        return F_MULTIPLE_VALUES;
    }
    
    static get F_MULTIPLE_DOCUMENTS() {
        return F_MULTIPLE_DOCUMENTS;
    }

    static get TEMP_TRANSLATIONS() {
        return TEMP_TRANSLATIONS;
    }

    static get FIELD_VALUE_TYPE_BY_JSTYPE() {
        return FIELD_VALUE_TYPE_BY_JSTYPE;
    }
    //#endregion
    
    //#region Public methods
    static validate(type, candidate, isRequired, mustBeTrue, isSubField) {

        if(type === F_STRING) {
            return validateString(candidate, isRequired, isSubField);
        }

        if(type === F_MULTILINE) {
            return validateString(candidate, isRequired);
        }
        
        if (type === F_EMAIL) {
            return validateEmail(candidate, isRequired);
        }

        if (type === F_POSTALCODE) {
            return validatePostalCode(candidate, isRequired);
        }

        if (type === F_DATE || type === F_BIRTHDATE) {
            return validateDate(candidate, isRequired);
        }

        if(type === F_BOOL) {
            return validateBool(candidate, isRequired, mustBeTrue);
        }
        
        if(type === F_TAGS) {
            return validateTags(candidate, isRequired);
        }

        if(type === F_DECIMAL) {
            return validateNumber(candidate, isRequired);
        }

        if(type === F_INT) {
            return validateInt(candidate, isRequired);
        }
    }

    static guessValueTypeOfOneOf(field) {
        if(field.valueType)
            return field.valueType;
        else if(field.possibleValues.length > 0)
                return FIELD_VALUE_TYPE_BY_JSTYPE[typeof(field.possibleValues[0].value)]; // Auto detect the type of the first possible value    
        return F_STRING;
    }
    
    static translate(key) { return TEMP_TRANSLATIONS[key]; }
    //#endregion
}

